
import React, { FC, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Validator from "simple-react-validator";
import { useSelector } from "react-redux";
import { errorFocus } from "../../../common/utils/function";
import { useForceUpdate } from "../../../common/hooks/useForceUpdate";
import { profileAccountService } from "../../../store/actions";

interface TransactionPrivateTagModalProps {
  show: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const TransactionPrivateTagModal: FC<TransactionPrivateTagModalProps> = ({
  show,
  onClose,
  onSuccess
}) => {
  const forceUpdate = useForceUpdate();
  const validator = useRef(
    new Validator({
      element: (message: string, className: string) => (
        <div className="red">{message}</div>
      ),
      autoForceUpdate: { forceUpdate },
    })
  );

  const _account = useSelector((e: Object) => (e as any)?.common?.account);
  
  const [txHash, setTxHash] = useState("");
  const [tag, setTag] = useState("");
  const signature = _account?.signature;
  const message = _account?.message;
  
  const handleSubmit = async () => {
    try {
      const data = {
        transaction: txHash,
        name: tag,
        message,
        signature,
      };
      const response = await profileAccountService.createTxPrivateNote(data);
      console.log(response);
      console.log("Form Data:", JSON.stringify(data));
      onSuccess();
    } catch (err) {
      console.log(err);
    }

    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} animation={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h5 className="modal-title fw-medium">Add a New Private Transaction Tag</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-lg-12">
            <div className="bs-field mb-3">
              <label htmlFor="txHash" className="form-label">Enter The Transaction Hash</label>
              <input
                type="text"
                id="txHash"
                className="form-control"
                placeholder="Enter an Tx Hash"
                value={txHash}
                onChange={(e) => setTxHash(e.target.value)}
              />
            </div>
            
            <div className="bs-field mb-3">
              <label htmlFor="tag" className="form-label">Private Tag</label>
              <textarea
                id="tag"
                className="form-control"
                placeholder="Private Tag"
                maxLength={500}
                value={tag}
                onChange={(e) => setTag(e.target.value)}
              />
              <small className="form-text text-muted">
                Character limit: {tag.length} / 500.
              </small>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <button 
          className="btn btn-ghost-white" 
          onClick={onClose}
        >
          Cancel
        </button>
        <Button 
          onClick={handleSubmit}
        >
          Create Private Transaction Tag
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TransactionPrivateTagModal;